
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class OwnershipProxyDialog extends SiteEntityDialog<OwnershipProxyRow, any> {
        protected getFormKey() { return OwnershipProxyForm.formKey; }
        protected getIdProperty() { return OwnershipProxyRow.idProperty; }
        protected getLocalTextPrefix() { return OwnershipProxyRow.localTextPrefix; }
        protected getNameProperty() { return OwnershipProxyRow.nameProperty; }
        protected getService() { return OwnershipProxyService.baseUrl; }

        protected form = new OwnershipProxyForm(this.idPrefix);
    }
}